<app-loading></app-loading>
<div class="app-container">
  <router-outlet></router-outlet>
</div>
